import React from 'react'
import SurveyTemplate from 'src/components/template/survey'
export default (props) => <SurveyTemplate url="https://fubo.typeform.com/to/VDZ0vIUI" />
